var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Mixins } from 'vue-property-decorator';
import { lazyInject } from '@/dependency-injection';
import { TYPES } from '@/dependency-injection/types';
import { ContractManagementService } from '@/services/contract-management/contract-management-service';
import SteppedPageMixin from '@/mixins/stepped-page-mixin';
import SnackbarMixin from '@/mixins/snackbar-mixin';
import { ValidationObserver } from 'vee-validate';
import DefaultPricingFormulasCrudSidesheet from '@/pages/contract-management/add-edit-contract/DefaultPricingFormulasStep/DefaultPricingFormulasCrudSidesheet.vue';
import DefaultPricingFormulasDeletePrompt from '@/pages/contract-management/add-edit-contract/DefaultPricingFormulasStep/DefaultPricingFormulasDeletePrompt.vue';
import DefaultPricingFormulasTable from '@/pages/contract-management/add-edit-contract/DefaultPricingFormulasStep/DefaultPricingFormulasTable.vue';
import * as format from 'date-fns/format';
var DefaultPricingFormulasStep = /** @class */ (function (_super) {
    __extends(DefaultPricingFormulasStep, _super);
    function DefaultPricingFormulasStep() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showAlert = false;
        _this.alertMessage = '';
        return _this;
    }
    Object.defineProperty(DefaultPricingFormulasStep.prototype, "contractId", {
        get: function () {
            var contract = this.item;
            return contract.contractId;
        },
        enumerable: false,
        configurable: true
    });
    DefaultPricingFormulasStep.prototype.moveToStep = function (step) {
        return __awaiter(this, void 0, void 0, function () {
            var contract, startDate, endDate, startDates, minStartDate, endDates, maxEndDate, shallPass_1, previousDefaultPricingFormula_1, firstCompEndDate_1, clone;
            var _this = this;
            return __generator(this, function (_a) {
                // clear the alert and message
                this.showAlert = false;
                this.alertMessage = '';
                contract = __assign({}, this.item);
                if (contract.defaultPricingFormulas.length === 0) {
                    this.showAlert = true;
                    this.alertMessage = 'At least one default pricing formula needs to be specified for this contract';
                    return [2 /*return*/];
                }
                else {
                    startDate = new Date(format(contract.startDate, 'MM/DD/YYYY HH:mm'));
                    endDate = contract.revisedEndDate && contract.revisedEndDate.length > 0 ? new Date(format(contract.revisedEndDate, 'MM/DD/YYYY HH:mm')) : new Date(format(contract.endDate, 'MM/DD/YYYY HH:mm'));
                    startDates = contract.defaultPricingFormulas.map(function (dpf) { return new Date(format(dpf.startDate, 'MM/DD/YYYY HH:mm')); });
                    minStartDate = new Date(Math.min.apply(null, startDates));
                    endDates = contract.defaultPricingFormulas.map(function (dpf) { return new Date(format(dpf.endDate, 'MM/DD/YYYY HH:mm')); });
                    maxEndDate = new Date(Math.max.apply(null, endDates));
                    // check for time gaps between contract startdate/enddate and dpf min-startdate/max-enddate
                    if (minStartDate < startDate || endDate > maxEndDate) {
                        this.showAlert = true;
                        this.alertMessage = 'There are time gaps in your selections. The sum of durations of all default pricing formulas must be equal to the duration of the contract.';
                    }
                    else {
                        shallPass_1 = true;
                        firstCompEndDate_1 = new Date(startDate.setHours(startDate.getHours() - 1));
                        clone = contract.defaultPricingFormulas.slice(0);
                        clone.sort(function (a, b) {
                            if (new Date(format(a.startDate, 'MM/DD/YYYY HH:mm')) > new Date(format(b.startDate, 'MM/DD/YYYY HH:mm'))) {
                                return 1;
                            }
                            if (new Date(format(a.startDate, 'MM/DD/YYYY HH:mm')) < new Date(format(b.startDate, 'MM/DD/YYYY HH:mm'))) {
                                return -1;
                            }
                            return 0;
                        }).forEach(function (dpf, index) {
                            // if no match then add to collection
                            var compEndDate = index === 0 ? firstCompEndDate_1 : new Date(format(previousDefaultPricingFormula_1.endDate, 'MM/DD/YYYY HH:mm'));
                            var compStartDate = new Date(format(dpf.startDate, 'MM/DD/YYYY HH:mm'));
                            // differences
                            var timeDiff = Math.abs(compEndDate.getTime() - compStartDate.getTime());
                            var hourDiff = timeDiff / (1000 * 3600);
                            // check for time gaps between dpf previous-enddate and current-startdate
                            if (hourDiff > 1) {
                                _this.showAlert = true;
                                _this.alertMessage = 'There are time gaps in your selections. The sum of durations of all default pricing formulas must be equal to the duration of the contract.';
                                shallPass_1 = false;
                            }
                            previousDefaultPricingFormula_1 = dpf;
                        });
                        if (shallPass_1) {
                            this.step = step;
                        }
                    }
                }
                return [2 /*return*/];
            });
        });
    };
    var _a;
    __decorate([
        lazyInject(TYPES.ContractManagementService),
        __metadata("design:type", typeof (_a = typeof ContractManagementService !== "undefined" && ContractManagementService) === "function" ? _a : Object)
    ], DefaultPricingFormulasStep.prototype, "contractManagementService", void 0);
    DefaultPricingFormulasStep = __decorate([
        Component({
            components: {
                ValidationObserver: ValidationObserver,
                DefaultPricingFormulasCrudSidesheet: DefaultPricingFormulasCrudSidesheet,
                DefaultPricingFormulasDeletePrompt: DefaultPricingFormulasDeletePrompt,
                DefaultPricingFormulasTable: DefaultPricingFormulasTable,
            },
        })
    ], DefaultPricingFormulasStep);
    return DefaultPricingFormulasStep;
}(Mixins(SteppedPageMixin, SnackbarMixin)));
export default DefaultPricingFormulasStep;
